import { Outlet } from 'react-router-dom';
import MainHeader from './header';
import { Button, Card, CardContent, Input, MenuItem, Select, Typography, Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { get, post } from 'api/apiBridges/httpBridge';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import { Email } from '@mui/icons-material';
import Loading from 'components/Load';
import Scrollbars from 'rc-scrollbars';
import { SocketContext } from 'components/socketLib/ConnectorSocket';
import { colors } from 'styles/colors';
import { NumInputDesign, TextInputDesign } from "../components/EIComponents/LittleComponents";


const ClientDocumentsSettings = () => {

  const { socket } = useContext(SocketContext);
  const { user_id} = useSelector(
      loginSelector
  );

  const [loading, setLoading] = useState(true);
  const [changed, setChanged] = useState(false);
  const [user, setUser] = useState({
      id: undefined, 
      data: {
        name: "",
        type: "",
        bank: "",
        korSchet: "",
        BICBank: "",
        rasSchet: "",
        INN: "",
        KPP: "",
        ORGN: "",
        ADDR: "",
        date: ""
      },
  })

  useEffect(() => {
    const fetchData = async () => {
        try {
        setLoading(true);
        const responseData = await get('UserRekv/get', {uid:user_id});
        if (responseData?.message) {
            let obj = {
                id:responseData.message.id,
                data: JSON.parse(responseData.message.data) || {},
            }
            setUser(obj)
        }
        } catch (err) {
        } finally {
        setLoading(false);
        }
    };

    fetchData();
  }, []); 

  const change = (path, val) => {
    let tmp = {...user}
    tmp.data[path] = val
    setUser(tmp)
    setChanged(true)
  }

  const save = async  () => {
    if (user.id) {
      await post('UserRekv/update', {user_id:user_id, data:user.data})
    }
    else {
      let tempid = await post('UserRekv/create', {user_id:user_id, data:user.data})
      setUser({...user, id: tempid.message})
    }
    socket.emit("update_user_rekv", {user_id})
    setChanged(false)
  }

  if (loading) {
      return <Loading></Loading>
  }

  return (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
      alignItems: "center",
      height: "100%",
      overflowY: "auto",
      paddingRight: "10px",
    }}
  >

    {/* ПОЛЯ */}

    <Box sx={{ width: "100%", padding: "10px 20px", marginTop:'30px' }}>
      <TextInputDesign
        title="ФИО/ИП/ООО:"
        val={user.data.name}
        onChange={(e) => change("name", e)}
        fontSize="18pt"
        adaptive
      />
    </Box>

    <Box sx={{ width: "100%", padding: "10px 20px", marginTop:'30px' }}>
      <Box display="flex" alignItems="center" sx={{ gap: "20px" }}>
        <Typography
          sx={{
            minWidth: "180px",
            fontSize: "18pt",
            color: "#838383",
          }}
        >
          Форма деятельности:
        </Typography>

        <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end", marginTop:'30px' }}>
          <ToggleButtonGroup
            value={user.data.type}
            exclusive
            onChange={(e, newValue) => {
              if (newValue !== null) {
                change("type", newValue);
              }
            }}
            sx={{
              height: "40px",
              gap:'40px',

              "& .MuiToggleButton-root": {
                textTransform: "none",
                padding: "6px 16px",
                border: "1px solid #ccc",
              },

              "& .Mui-selected": {
                backgroundColor: "#078376",
                color: "#fff",

                "&:hover": {
                  backgroundColor: "#06695f",
                },
              },
            }}
          >
            <ToggleButton value="ИП" style={{borderRadius:'12px', width:'100px', fontSize:'18pt'}}>
              ИП
            </ToggleButton>

            <ToggleButton value="ООО" style={{borderRadius:'12px', width:'100px', fontSize:'18pt'}}>
              ООО
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      </Box>
    </Box>

    <Box sx={{ width: "100%", padding: "10px 20px", marginTop:'30px' }}>
      <TextInputDesign
        title="Название банка:"
        val={user.data.bank}
        onChange={(e) => change("bank", e)}
        adaptive
      />
    </Box>

    <Box sx={{ width: "100%", padding: "10px 20px" , marginTop:'30px'}}>
      <TextInputDesign
        title="Корреспондентский счет:"
        val={user.data.korSchet}
        onChange={(e) => change("korSchet", e)}
        adaptive
      />
    </Box>

    <Box sx={{ width: "100%", padding: "10px 20px", marginTop:'30px' }}>
      <TextInputDesign
        title="БИК банка:"
        val={user.data.BICBank}
        onChange={(e) => change("BICBank", e)}
        adaptive
      />
    </Box>

    <Box sx={{ width: "100%", padding: "10px 20px", marginTop:'30px' }}>
      <TextInputDesign
        title="Расчетный счет:"
        val={user.data.rasSchet}
        onChange={(e) => change("rasSchet", e)}
        adaptive
      />
    </Box>

    <Box sx={{ width: "100%", padding: "10px 20px" }}>
      <TextInputDesign
        title="ИНН:"
        val={user.data.INN}
        onChange={(e) => change("INN", e)}
        adaptive
      />
    </Box>

    <Box sx={{ width: "100%", padding: "10px 20px" }}>
      <TextInputDesign
        title="КПП:"
        val={user.data.KPP}
        onChange={(e) => change("KPP", e)}
        adaptive
      />
    </Box>

    <Box sx={{ width: "100%", padding: "10px 20px" }}>
      <TextInputDesign
        title="ОГРН:"
        val={user.data.ORGN}
        onChange={(e) => change("ORGN", e)}
        adaptive
      />
    </Box>

    <Box sx={{ width: "100%", padding: "10px 20px" }}>
      <TextInputDesign
        title="Адрес:"
        val={user.data.ADDR}
        onChange={(e) => change("ADDR", e)}
        adaptive
      />
    </Box>

    <Box sx={{ width: "100%", padding: "10px 20px" }}>
      <TextInputDesign
        title="Дата регистрации:"
        val={user.data.date}
        onChange={(e) => change("date", e)}
        adaptive
      />
    </Box>

    {/* КНОПКА */}

    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
        padding: "0 20px 20px 20px",
      }}
    >
      {changed && (
        <Button
          onClick={save}
          variant="contained"
          sx={{
            textTransform: "none",
            backgroundColor: colors.elements,
            fontWeight: "bold",
          }}
        >
          Сохранить
        </Button>
      )}
    </div>
  </div>
);
};

export default ClientDocumentsSettings;
